import { useEffect, useState } from 'react';

export function useViewport() {
  const read = () => {
    const vv = window.visualViewport;
    return {
      width: window.innerWidth, // viewport width
      height: window.innerHeight, // viewport height (CSS px)
      vvw: vv?.width ?? null, // visual viewport width (accounts for UI/zoom)
      vvh: vv?.height ?? null, // visual viewport height
      screenW: window.screen?.width ?? null, // screen width in CSS px
      screenH: window.screen?.height ?? null, // screen height in CSS px
      dpr: window.devicePixelRatio || 1,
    };
  };

  const [vp, setVp] = useState(read);

  useEffect(() => {
    let raf = 0;
    const onResize = () => {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(() => setVp(read()));
    };

    window.addEventListener('resize', onResize);

    // visualViewport catches toolbar/zoom/IME changes (mobile & desktop Chromium)
    window.visualViewport?.addEventListener('resize', onResize);
    window.visualViewport?.addEventListener('scroll', onResize); // sometimes height changes on scroll on mobile

    onResize(); // initial

    return () => {
      window.removeEventListener('resize', onResize);
      window.visualViewport?.removeEventListener('resize', onResize);
      window.visualViewport?.removeEventListener('scroll', onResize);
      cancelAnimationFrame(raf);
    };
  }, []);

  return vp;
}
